import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 font-label">
            Opinie użytkowników
          </span>
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950 leading-tight max-w-2xl">
            Co mówią nasi czytelnicy
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {[0, 1, 2].map((colIndex) => (
            <div key={colIndex} className="space-y-4 md:space-y-6">
              {[colIndex * 2, colIndex * 2 + 1].map((itemIndex) => {
                const t = testimonials[itemIndex];
                if (!t) return null;
                return (
                  <div
                    key={itemIndex}
                    className="bg-white rounded-2xl p-5 md:p-6 transition-all duration-300 hover:-translate-y-1"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0">
                        <i className="ri-user-line text-secondary-600"></i>
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                        <p className="text-xs text-foreground-500">{t.username}</p>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      &ldquo;{t.content}&rdquo;
                    </p>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}